import { FC } from 'react'
import FavoritesLayout from './layout'
import FavoritesLogic from './logic'

interface FavoritesProps {
  className?: string
}

const Favorites: FC<FavoritesProps> = ({ className }) => {
  return <FavoritesLogic Wrapper={FavoritesLayout} className={className} />
}

export default Favorites
